<template>
  <div class="process_box">
    <processHead class="process_head" @update:fromGrandchild="updateMes" :nowId="nowId" :pageNum="pageNum" />
    <processBody :coilingList="coilingList" ref="processBodyRef" class="process_body"/>
  </div>
</template>
<script>
import processHead from "./processHead";
import processBody from "./processBody";
export default {
  name: "answeringProcess",
  components: {
    processHead,
    processBody,
  },
  props: {
    nowId: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: String
    }
  },
  

  directives: {
    //局部自定义指令
    // focus: {
    // 当被绑定的元素插入到 DOM 中时……
    // inserted: function (el) {
    // el.focus()
    // }
    //}
    //<input v-focus>
  },

  filters: {
    //{{ date | dateFormatter }}
    //<div v-bind:id="data |dateFormatter "></div>
    //{{ message |dateFormatter(param1,param2)}}
    //在script脚本区域//调用全局过滤器
    //this.$root.$options.filters.dateFormatter
  },
  data() {
    return {
      coilingList: []
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    updateMes(data) {
      this.$emit("update:fromGrandchild", data);
    },
    scjShow(data) {
      this.$emit('scjShow', data);
    },
    showTopicData(){
      this.$refs.processBodyRef.showTopicData()
    },
    operateInsertProgressCollection(direction, id, fields){
        console.log('progress开始调用operateInsertProgressCollection')
        this.$refs.processBodyRef.operateInsertProgressCollection(direction, id, fields)
    },
  },
};
</script>
<style lang="scss" scoped>
.process_box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20rem;
  border-radius: 12rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  .process_body {
    margin-top: 22rem;
  }
}
</style>